import * as React from "react"
import Svg, {Path, G, SvgProps} from "react-native-svg"

const LogoutIcon: React.FC<SvgProps> = ({width = 24, height = 24, color = '#323232'}) => {
    return (
        <Svg
            width={width}
            height={height}
            viewBox="0 0 341 371"
            fill="none"
        >
            <G transform="matrix(-4.78363e-17,-0.544607,0.883721,1.35296e-16,4.17659,232.819)">
                <Path
                    d="M138.615,199.393C128.466,199.393 120.225,194.315 120.225,188.06C120.225,181.805 128.466,176.726 138.615,176.726L376.057,176.726C386.207,176.726 394.448,181.805 394.448,188.06C394.448,194.315 386.207,199.393 376.057,199.393L138.615,199.393Z"
                    fill={"#71706F"}
                />
            </G>
            <G transform="matrix(0.77985,0,0,0.77985,18.0072,48.5341)">
                <Path
                    d="M280.821,44.14C274.731,40.513 272.731,32.624 276.358,26.534C279.985,20.444 287.874,18.444 293.964,22.071C350.518,55.751 388.434,117.514 388.434,188.06C388.434,294.613 301.926,381.121 195.373,381.121C88.82,381.121 2.312,294.613 2.312,188.06C2.312,117.514 40.228,55.751 96.782,22.071C102.872,18.444 110.761,20.444 114.388,26.534C118.015,32.624 116.015,40.513 109.925,44.14C60.887,73.343 27.998,126.89 27.998,188.06C27.998,280.437 102.996,355.435 195.373,355.435C287.75,355.435 362.748,280.437 362.748,188.06C362.748,126.89 329.859,73.343 280.821,44.14Z"
                    fill={"#71706F"}
                />
            </G>
        </Svg>
    )
}

export default LogoutIcon